exports = module.exports = require("../../../../../../../../../../../L180/prototypes/uni-uswebapp/node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".mylable{font-size:10px}", "", {"version":3,"sources":["C:/Users/vijay/AppData/Local/Temp/claude/e765c3a26afc9a32/165e99a4-2433-4693-95f2-2e25055bc364/scratchpad/deploy/us/src/components/Staff.vue"],"names":[],"mappings":"AACA,SACE,cAAe,CAChB","file":"Staff.vue","sourcesContent":["\n.mylable{\n  font-size:10px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// C:/Users/vijay/L180/prototypes/uni-uswebapp/~/css-loader?{"minimize":true,"sourceMap":true}!C:/Users/vijay/L180/prototypes/uni-uswebapp/~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5e80fcf6","scoped":false,"hasInlineConfig":false}!C:/Users/vijay/L180/prototypes/uni-uswebapp/~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Staff.vue
// module id = 820
// module chunks = 8